import React from 'react';

// Import CSS bạn vừa tạo
import './ContactSection.css';

const ContactSection = ({ data }) => {
  // Nếu chưa có dữ liệu, không render gì cả
  if (!data) {
    return null;
  }

  // Chuẩn bị một mảng dữ liệu để dễ dàng render
  const contactItems = [
    {
      key: 'address',
      iconClass: 'fa-solid fa-location-dot',
      text: data.Address,
      href: data.Googlemap // Link đến Google Maps khi click vào địa chỉ
    },
    {
      key: 'phone',
      iconClass: 'fa-solid fa-phone',
      text: data.Phone,
      href: `tel:${data.Phone}`
    },
    {
      key: 'email',
      iconClass: 'fa-solid fa-envelope',
      text: data.Email,
      href: `mailto:${data.Email}`
    },
    {
      key: 'zalo',
      iconClass: null, // Sử dụng icon comment cho Zalo
      text: data.Zalo,
      icon: '/Images/Icon_of_Zalo.jpg',
      href: 'https://zalo.me/' + String(data.Zalo).replace(/\s+/g, "")
      // Zalo không có link web chuẩn, nên không thêm href
    },
    {
      key: 'facebook',
      iconClass: null, // Icon facebook brand
      text: 'Facebook', // Thường sẽ hiển thị chữ "Facebook" thay vì cả link
      href: data.Facebook,
      icon: '/Images/facebook-logo-facebook-icon-transparent-free-png.jpg',
    }
  ];

  return (
    <div className="map-contact-wrapper">
      <div className="container">
        <div className="map-contact-layout">

          {/* Cột thông tin liên hệ */}
          <div className="contact-info">
            <h3 className="contact-info__title">Thông tin liên hệ</h3>
            {contactItems.map(item => {
              // Chỉ render nếu có text
              if (!item.text) return null;

              return (
                <div className="contact-item" key={item.key}>
                  {item.icon ? (
                    <img
                      src={item.icon}
                      alt={item.key}
                      style={{
                        width: 18,
                        height: 18,
                        objectFit: "contain",
                        marginRight: 10
                      }}
                    />
                  ) : (
                    <i className={item.iconClass}></i>
                  )}

                  <span>
                    {item.href ? (
                      <a href={item.href} target="_blank" rel="noopener noreferrer">
                        {item.text}
                      </a>
                    ) : (
                      item.text
                    )}
                  </span>
                </div>
              );
            })}
          </div>

          {/* Cột bản đồ */}
          {data.Googlemap && (
            <div className="map-embed">
              <iframe
                src={data.Googlemap}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade">
              </iframe>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

// Bạn có thể đổi tên export cho phù hợp với dự án
export default ContactSection; 